import PropTypes from 'prop-types'
import { createContext, useContext, useEffect, useState } from 'react'

// Crea un contexto para gestionar el estado del usuario actual
export const UserContext = createContext(null)

// Proveedor del contexto del usuario actual. Envuelve los componentes hijos y proporciona las funciones para manejar el usuario actual
export const UserProvider = ({ children }) => {
  // Estado para el usuario actual, inicializado desde localStorage si existe
  const [user, setUser] = useState(
    localStorage.getItem('user')
      ? JSON.parse(localStorage.getItem('user'))
      : null
  )

  // Guarda el estado del usuario en localStorage cada vez que este cambia
  useEffect(() => {
    localStorage.setItem('user', JSON.stringify(user))
  }, [user])

  return (
    // Proporciona el estado y las funciones del usuario actual a los componentes hijos
    <UserContext.Provider value={{ user, setUser }}>
      {children}
    </UserContext.Provider>
  )
}

// Hook personalizado para usar el contexto del usuario actual de forma más sencilla
export const useUser = () => useContext(UserContext)

// Define los tipos de las props que recibe el componente actual
UserProvider.propTypes = {
  children: PropTypes.any
}
